var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeaderTeam',{attrs:{"header":"ตารางการทำงาน","img_header":_vm.header_image,"link_back":"manageworkschedule"}}),_c('AllScheduleList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }